export default __webpack_public_path__ + "static/media/my-trainging-h1.b39d2d13.svg";